import React from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import btc from "./assets/utility/bitcoin.png";
import eth from "./assets/utility/ethereum.png";
import matic from "./assets/utility/matic.png";
import CRANNI from "./assets/utility/CRANNI.png";
import { Ticket } from "lucide-react";
import { useT } from "./i18n";

const LOTTERIES = [
	{ key: "", label: "BTC", to: "/", icon: btc },
	{ key: "ethereum", label: "ETH", to: "/ethereum", icon: eth },
	{ key: "matic", label: "POL", to: "/matic", icon: matic },
	{ key: "CRANNI", label: "CRANNI", to: "/CRANNI", icon: CRANNI },
];

const Main = () => {
	const t = useT();
	const location = useLocation();
	const current = location.pathname.split("/")[1];

	return (
		<section className="w-full">
			<div className="mx-auto w-full max-w-screen-2xl px-3 pt-6 sm:px-10">
				<nav aria-label={t("main.selector")} className="flex w-full justify-center">
					<div className="lb-seg">
						{LOTTERIES.map((item) => (
							<Link
								key={item.label}
								to={item.to}
								aria-current={current === item.key ? "page" : undefined}
								data-active={current === item.key}
								className="lb-seg-item notranslate"
							>
								<img
									src={item.icon}
									alt=""
									aria-hidden="true"
									className="h-4 w-4 shrink-0"
								/>
								{item.label}
							</Link>
						))}

						{/* Hidden once the rail wraps, since a divider mid-wrap reads as noise. */}
						<span
							className="mx-1 hidden h-5 w-px shrink-0 bg-white/10 sm:block"
							aria-hidden="true"
						/>

						<Link
							to="/my-tickets"
							aria-current={current === "my-tickets" ? "page" : undefined}
							data-active={current === "my-tickets"}
							data-tone="gold"
							className="lb-seg-item"
						>
							<Ticket className="h-4 w-4 shrink-0" aria-hidden="true" />
							{t("nav.myTickets")}
						</Link>
					</div>
				</nav>
				<Outlet />
			</div>
		</section>
	);
};

export default Main;
